// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA0Tz5YtxyTkgMpnSptediSb_ofR9irAaY",
  authDomain: "agro-log-1b106.firebaseapp.com",
  projectId: "agro-log-1b106",
  storageBucket: "agro-log-1b106.appspot.com",
  messagingSenderId: "233643836291",
  appId: "1:233643836291:web:f86d9ff352653af7f82cb6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth= getAuth(app)
export {app,auth}